import { Card, CardBody, CardFooter, CardHeader, Text } from '@backstage/ui';

import type { ReactNode } from 'react';
import styles from './KpiCard.module.css';

interface KpiCardProps {
  label: string;
  colSpan?: number;
  grow?: number | boolean;
  value?: ReactNode;
  unit?: string;
  caption?: string;
  valueColor?: string;
  children?: ReactNode;
  footer?: ReactNode;
}

export const KpiCard = ({
  label,
  colSpan,
  grow,
  value,
  unit,
  caption,
  valueColor,
  children,
  footer,
}: KpiCardProps) => (
  <Card
    grow={grow}
    style={colSpan ? { gridColumn: `span ${colSpan}` } : undefined}
  >
    <CardHeader>
      <Text as="p" variant="body-small" weight="bold" className={styles.label}>
        {label}
      </Text>
    </CardHeader>
    <CardBody>
      {children ?? (
        <>
          <Text as="p" className={styles.value}>
            <Text
              as="span"
              variant="title-medium"
              style={{ color: valueColor }}
            >
              {value}
            </Text>
            {unit && (
              <Text as="span" variant="body-large" color="primary">
                {' '}
                {unit}
              </Text>
            )}
          </Text>
          {caption && (
            <Text
              as="p"
              variant="body-small"
              color="secondary"
              className={styles.caption}
            >
              {caption}
            </Text>
          )}
        </>
      )}
    </CardBody>
    {footer && <CardFooter>{footer}</CardFooter>}
  </Card>
);
